/*eslint-disable*/
import React, { useState, useContext, useEffect } from "react";
import {
  TextField,
  Typography,
  Divider,
  Paper,
  Grid,
  Button,
  Box
} from "@mui/material";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";
import { FirebaseContext } from "common";
import { STYLES } from "config";
import { useDispatch, useSelector } from "react-redux";

function BrokerDetailsComponent(props) {
  const { api } = useContext(FirebaseContext);
  const { fetchBroker, fetchAgent } = api;
  const dispatch = useDispatch();
  const { data, setvalue } = props;
  const broker = useSelector((state) => state.brokersdata.broker);
  const [state, setstate] = useState(data);

  useEffect(() => {
    setstate(data);
  }, [data]);

  const updateData = (e) => {
    const updatedState = { ...state, [e.target.name]: e.target.value };
    setstate(updatedState);
    setvalue(updatedState);
    console.log("updatedState", updatedState);
  };

  const updateDataNested = (e) => {
    const { name, value } = e.target;

    if (name === "fullName") {
      const [Name, ...lastNameParts] = value.split(" ");
      const lastName = lastNameParts.join(" ");

      const updatedState = {
        ...state,
        userdetials: {
          ...state.userdetials,
          Name: Name || "",
          lastName: lastName || ""
        }
      };

      setstate(updatedState);
      setvalue(updatedState);
    } else {
      const keys = name.split(".");
      const updatedState = { ...state };
      let current = updatedState;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]] = current[keys[i]] || {};
      }
      current[keys[keys.length - 1]] = value;
      setstate(updatedState);
      setvalue(updatedState);
    }
  };

  const handleDropdownChange = (name, value) => {
    const keys = name.split(".");
    const updatedState = { ...state };

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]] = current[keys[i]] || {};
    }
    current[keys[keys.length - 1]] = value;

    setstate(updatedState);
    setvalue(updatedState);
  };

  useEffect(() => {
    try {
      if (data.userdetials.id) {
        fetchBroker(data.userdetials.id);
      }
    } catch (error) {
      console.log(error);
    }
  }, [data]);

  const formatPhoneNumber = (number) => {
    return number.replace(/(\+27)0(\d+)/, "$1$2").trim();
  };

  const handleSubmit = () => {
    let agentData = {
      firstname: data.userdetials.Name ? data.userdetials.Name : "",
      lastname: data.userdetials.lastName ? data.userdetials.lastName : "",
      receiveStatsMail: true,
      published: true,
      agencyId: 31335,
      cityId: 123,
      sourceReference: data.userdetials.id,
      mobileNumber: formatPhoneNumber(data.userdetials.mobile)
        ? formatPhoneNumber(data.userdetials.mobile)
        : "",
      emailAddress: data.userdetials.email ? data.userdetials.email : "",
      isBroker: true,
      countryId: 1,
      profile: {
        id: 123,
        facebook: "https://www.facebook.com/MyAgency",
        twitter: "https://twitter.com/MyAgency"
      },
      status: "Active",
      jobTitle: "Broker"
    };
    // dispatch(addAgent(data, data.userdetials.id));
  };

  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 400,
            mb: 1,
            color: STYLES.WEB_APP_FONT_CLR
          }}
        >
          Broker Details
        </Typography>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
          <Typography variant="body1" paragraph>
            If this button appears, it means the system hasn't yet confirmed
            whether the broker's profile exists on Private Property or
            Property24.
          </Typography>
          <Typography variant="body1" paragraph>
            Clicking the button will trigger a verification process that checks
            both platforms for the broker's presence.
          </Typography>
          <Typography
            variant="body1"
            paragraph
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <span>
              <strong>Admin Action Required:</strong> Please click the button to
              ensure the broker's details are correctly linked. This step helps
              maintain accurate listings and ensures seamless integration with
              both property portals.
            </span>
          </Typography>
        </Paper>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Broker Full Name:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="fullName"
              size="small"
              value={data?.userdetials.Name + " " + data?.userdetials.lastName}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Email:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="userdetials.email"
              size="small"
              type="email"
              value={data?.userdetials.email || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Contact Number:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="userdetials.mobile"
              size="small"
              value={data?.userdetials.mobile || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>

          <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

          <Grid item size={6}>
            {!broker?.agentId && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{ mb: 2 }}
              >
                Check Property24
              </Button>
            )}
          </Grid>
          {/* <Grid item size={6}>
            <Button variant="contained" color="primary" sx={{ mb: 2 }}>
              Check Private Property
            </Button>
          </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
}

export default BrokerDetailsComponent;
